import { render, staticRenderFns } from "./RedeemVoucherToCourse.vue?vue&type=template&id=4d685b83&scoped=true"
import script from "./RedeemVoucherToCourse.vue?vue&type=script&lang=ts"
export * from "./RedeemVoucherToCourse.vue?vue&type=script&lang=ts"
import style0 from "./RedeemVoucherToCourse.vue?vue&type=style&index=0&id=4d685b83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d685b83",
  null
  
)

export default component.exports